import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { buttonVariants } from "../../ui/button";
import { cn } from "../../lib/utils";
import { useLocation } from "react-router-dom";
import {
  setPaginationSecondValue,
  setPaginationFirstValue,
  setRecordsShow,
  setIsVisible,
  getBonusTableList,
  getUserFreeSpinConfig,
  setFreeSpinConfig,
} from "./BonusSlice.js";
import {
  convertToUSD,
  formatMoney,
  getDateTimeFormate,
  getIsOssino,
} from "../../sharedfiles/helper";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import Vpagination from "../../sharedfiles/Vpagination";
import Table from "../Common/table/Table";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import NoDataFound from "../Common/table/NoDataFound";
import { Table as ShadcnTable, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../ui/table";
import { useColumnPreferences } from "../../sharedfiles/hooks/useColumnPreferences";

const ViewFreeSpinButton = ({ userBonusId, userId, onViewClick }) => {
  const handleClick = () => {
    onViewClick(userBonusId, userId);
  };

  return (
    <span
      onClick={handleClick}
      className={cn(buttonVariants({ variant: "default", size: "sm" }), "cursor-pointer")}
    >
      View
    </span>
  );
};

const Bonus = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [csvData, setCsvData] = useState([]);
  const [pdfBody, setPdfBody] = useState([]);
  const [payload, setPayload] = useState({});
  const userId = props.userId ? props.userId : localStorage.getItem("userId");
  const [freeSpinDialog, setFreeSpinDialog] = useState(false);
  const [freeSpinData, setFreeSpinData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const freeUserSpinConfig = useSelector((p) => p.bonusSlice.freeSpinConfig);

  const isOssino = getIsOssino();

  useEffect(() => {
    if (Array.isArray(freeUserSpinConfig) && freeUserSpinConfig.length > 0) {
      const formattedData = freeUserSpinConfig.map((item) => ({
        id: item.id,
        bonusId: item.bonusId,
        freeSpinConfigId: item.freeSpinConfigId,
        providerName: item.providerName,
        subProviderName: item.subProviderName,
        category: item.category,
        gameName: item.gameName,
        gameCode: item.gameCode,
        freeSpinAmount: item.freeSpinAmount,
        freeSpinsAllocated: item.freeSpinsAllocated,
        freeSpinsRemaining: item.freeSpinsRemaining,
        freeSpinsUsed: item.freeSpinsUsed,
        freeSpinMaxWinAmount: item.freeSpinMaxWinAmount,
        validFrom: getDateTimeFormate(item.validFrom),
        validTo: getDateTimeFormate(item.validTo),
        createdDate: getDateTimeFormate(item.createdDate),
        updatedDate: getDateTimeFormate(item.updatedDate),
        isActive: item.isActive ? "Yes" : "No",
      }));
      setFreeSpinData(formattedData);
      // console.log('Formatted free spin data:', formattedData);
    } else {
      setFreeSpinData([]);
      // console.log('No free spin data available');
    }
  }, [freeUserSpinConfig]);

  const callApi = (pageNumber, itemsPerPage) => {
    dispatch(setIsVisible(false));
    dispatch(
      getBonusTableList(
        pageNumber - 1,
        itemsPerPage,
        localStorage.getItem("userId")
      )
    );
    setCsvData([]);
  };

  const freeSpinHeaders = [
    [
      "ID",
      "Bonus ID",
      "Free Spin Config ID",
      "Provider Name",
      "Sub Provider Name",
      "Category",
      "Game Name",
      "Game Code",
      "Free Spin Amount",
      "Free Spins Allocated",
      "Free Spins Remaining",
      "Free Spins Used",
      "Free Spin Max Win Amount",
      "Valid From",
      "Valid To",
      "Created Date",
      "Updated Date",
      "Is Active",
    ],
  ];

  const headers = [
    [
      "ID",
      "Bonus Type",
      "Bonus Sub Type",
      "Bonus Code",
      "Locked Bonus",
      "Unlocked Bonus",
      "Rollover Times",
      "Bonus Criteria",
      "Max Bonus Winning Amount",
      ...(isOssino ? ["Max Bonus Winning Amount (USD)"] : []),
      "Remaining Bonus Winning Amount ",
      ...(isOssino ? ["Remaining Bonus Winning Amount (USD)"] : []),
      "Max Winning Amount Used",
      ...(isOssino ? ["Max Winning Amount Used (USD)"] : []),
      "Max win Percentage",
      "Bonus Status",
      "Free Spin Config",
      "RC Applicable Type",
      "RC Odds Threshold",
      "Added Date",
      "Expiry Date",
      "Updated Date",
      "Created By",
    ],
  ];

  const info = [
    "Showing ID",
    "Showing the Bonus Type",
    "Showing Bonus Sub Type",
    "Showing Bonus Code",
    "Showing Locked Bonus",
    "Showing Unlocked Bonus",
    "Showing Rollover Times",
    "Showing Bonus Criteria",
    "Showing Max Bonus Winning Amount",
    ...(isOssino ? ["Showing Max Bonus Winning Amount (USD)"] : []),
    "Showing Remaining Bonus Winning Amount ",
    ...(isOssino ? ["Showing Remaining Bonus Winning Amount (USD)"] : []),
    "Showing Max Winning Amount Used",
    ...(isOssino ? ["Showing Max Winning Amount Used (USD)"] : []),
    "Showing Max win Percentage",
    "Showing Bonus Status",
    "Showing Free Spin Config",
    "Showing Release Criteria Applicable Type",
    "Showing Rrlease Criteria Odds Threshold",
    "Showing Added Date",
    "Showing Expiry Date",
    "Showing Updated Date",
    "Showing Created By",
  ];

  const exportPDF = () => {
    const title = "Bonus Report";
    exportPDFC(title, headers, pdfBody);
  };

  // Row cells below, aligned positionally with `headers[0]` above (same
  // conditional isOssino USD-column inserts, same order) so reorder/hide
  // work correctly and the pre-existing header/row misalignment (headers
  // included USD columns but rows never rendered a matching cell) is fixed.
  const bonusCellClassName = [
    "text-sm font-mono whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm text-right font-medium whitespace-nowrap",
    "text-sm text-right font-medium whitespace-nowrap",
    "text-sm text-right whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm text-right font-medium whitespace-nowrap",
    ...(isOssino ? ["text-sm text-right font-medium whitespace-nowrap"] : []),
    "text-sm text-right font-medium whitespace-nowrap",
    ...(isOssino ? ["text-sm text-right font-medium whitespace-nowrap"] : []),
    "text-sm text-right font-medium whitespace-nowrap",
    ...(isOssino ? ["text-sm text-right font-medium whitespace-nowrap"] : []),
    "text-sm text-right whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
    "text-sm whitespace-nowrap",
  ];

  useEffect(() => {
    updateTableData();
  }, [props.bonusData]);

  const handleFreeSpinView = async (userBonusId, userId) => {
    setIsLoading(true);
    try {
      await dispatch(getUserFreeSpinConfig(userBonusId, userId));
      setFreeSpinDialog(true);
    } catch (error) {
      console.error("Error fetching free spin config:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateTableData = () => {
    if (Object.keys(props.bonusData).length > 0) {
      const data =
        props.bonusData &&
        props.bonusData !== undefined &&
        Object.keys(props.bonusData).length > 0 &&
        props.bonusData.data &&
        Array.isArray(props.bonusData.data) &&
        props.bonusData.data.map((p) => [
          p.userBonusId,
          p.bonusType,
          Array.isArray(p.bonusSubType)
            ? p.bonusSubType.join(", ")
            : p.bonusSubType,
          p.bonusCode || "-",
          p.lockedBonus,
          p.unlockedBonus,
          p.rollOverMultiplier,
          p.bonusCriteria,
          p.maxWinAmount,
          ...(isOssino ? [p.maxWinAmountUsd ?? "-"] : []),
          p.maxWinAmountRemaining,
          ...(isOssino ? [p.maxWinAmountRemainingUsd ?? "-"] : []),
          p.maxWinAmountUsed,
          ...(isOssino ? [p.maxWinAmountUsedUsd ?? "-"] : []),
          p.maxWinPercentage,
          p.status,
          p.isFreeSpinBonus ? "View" : "N/A",
          p.unlockApplicableType,
          p.unlockOddsThreshold,
          p.addedDate ? getDateTimeFormate(p.addedDate) : "-",
          p.bonusExpiry ? getDateTimeFormate(p.bonusExpiry) : "-",
          p.updatedDate ? getDateTimeFormate(p.updatedDate) : "-",
          p.addedBy || "-",
        ]);

      const updatedData =
        data && data.length > 0
          ? [headers[0], info, ...data]
          : [headers[0], info, []];
      setCsvData(updatedData);
      setPdfBody(data);
    }
  };

  useEffect(() => {
    let mounting = true;

    if (mounting) {
      const paylaod = {
        pageNumber: props.activePages,
        itemsPerPage: props.paginationSecondValue,
      };
      setPayload(paylaod);
      callApi(1, 25);
    }
    return () => (mounting = false);
  }, []);

  useEffect(() => {
    let mounting = true;
    const id = location.pathname.split("/")[2];
    const isToCall = props.userId !== id;
    if (mounting && isToCall) {
      dispatch(getBonusTableList(0, 25, id));
    }
    return () => (mounting = false);
  }, [location.pathname]);

  const handleDialogClose = () => {
    setFreeSpinDialog(false);
    setFreeSpinData([]);
    dispatch(setFreeSpinConfig([]));
  };

  const bonusRowAccessors = [
    (item) => item.userBonusId,
    (item) => item.bonusType,
    (item) => (Array.isArray(item.bonusSubType) ? item.bonusSubType.join(", ") : item.bonusSubType),
    (item) => item.bonusCode || "-",
    (item) => item.lockedBonus,
    (item) => item.unlockedBonus,
    (item) => item.rollOverMultiplier,
    (item) => item.bonusCriteria,
    (item) => item.maxWinAmount,
    ...(isOssino ? [(item) => item.maxWinAmountUsd ?? "-"] : []),
    (item) => item.maxWinAmountRemaining,
    ...(isOssino ? [(item) => item.maxWinAmountRemainingUsd ?? "-"] : []),
    (item) => item.maxWinAmountUsed,
    ...(isOssino ? [(item) => item.maxWinAmountUsedUsd ?? "-"] : []),
    (item) => item.maxWinPercentage,
    (item) => (
      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-400">
        {item.status}
      </span>
    ),
    (item) =>
      item.isFreeSpinBonus ? (
        <ViewFreeSpinButton
          userBonusId={item.userBonusId}
          userId={userId}
          onViewClick={handleFreeSpinView}
        />
      ) : (
        <span className="text-muted-foreground">N/A</span>
      ),
    (item) => item.unlockApplicableType,
    (item) => item.unlockOddsThreshold,
    (item) => (item.addedDate ? getDateTimeFormate(item.addedDate) : "-"),
    (item) => (item.bonusExpiry ? getDateTimeFormate(item.bonusExpiry) : "-"),
    (item) => (item.updatedDate ? getDateTimeFormate(item.updatedDate) : "-"),
    (item) => item.addedBy || "-",
  ];
  const { visibleIndices, allColumns, toggleVisibility, reorder, resetToDefault } =
    useColumnPreferences("bonusesBonus", headers[0]);

  return (
    <React.Fragment>
      <Dialog open={freeSpinDialog} onOpenChange={handleDialogClose}>
        <DialogContent className="w-[80vw] max-w-[80vw] h-[85vh] flex flex-col p-0">
          <DialogHeader className="px-6 py-5 border-b shrink-0">
            <DialogTitle className="text-lg font-semibold">Free Spin Configuration & Details</DialogTitle>
          </DialogHeader>
          <div className="flex-1 p-5 overflow-hidden">
            {isLoading ? (
              <div className="flex items-center justify-center h-full">
                <div className="CMS-loader"></div>
              </div>
            ) : (
              <div className="h-full rounded-lg border bg-muted/30 overflow-auto">
                <ShadcnTable>
                  <TableHeader>
                    <TableRow>
                      {freeSpinHeaders[0].map((header, index) => (
                        <TableHead key={index} className="whitespace-nowrap">{header}</TableHead>
                      ))}
                    </TableRow>
                  </TableHeader>
                  <TableBody>
                    {freeSpinData && freeSpinData.length > 0 ? (
                      freeSpinData.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell className="text-sm whitespace-nowrap">{item.id}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.bonusId}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.freeSpinConfigId}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.providerName}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.subProviderName}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.category}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.gameName}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.gameCode}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.freeSpinAmount}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.freeSpinsAllocated}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.freeSpinsRemaining}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.freeSpinsUsed}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.freeSpinMaxWinAmount}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.validFrom}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.validTo}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.createdDate}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.updatedDate}</TableCell>
                          <TableCell className="text-sm whitespace-nowrap">{item.isActive}</TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <NoDataFound colspan={18} />
                    )}
                  </TableBody>
                </ShadcnTable>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
      <div className="rounded-lg border bg-card shadow-lg">
        <div className='bg-gradient-to-r from-purple-50 to-pink-50 dark:from-gray-800 dark:to-gray-700 px-6 py-4 border-b'>
          <h2 className='text-xl font-semibold text-gray-800 dark:text-gray-100'>Player Bonuses</h2>
          <p className='text-sm text-gray-600 dark:text-gray-400 mt-1'>View and manage all active player bonus allocations</p>
        </div>
        <div className="px-6 py-4 border-b bg-muted/20">
          <Vpagination
            data={props.bonusData?.data}
            totalRecords={props.bonusData.totalRecords}
            paginationFirstValue={props.paginationFirstValue}
            paginationSecondValue={props.paginationSecondValue}
            setPaginationFirstValue={setPaginationFirstValue}
            setPaginationSecondValue={setPaginationSecondValue}
            recordsShow={props.recordsShow}
            setRecordsShow={setRecordsShow}
            isVisible={props.isVisible}
            setIsVisible={setIsVisible}
            csvData={csvData}
            exportPDF={exportPDF}
            callApi={callApi}
            csvFileName={"Bonus Report"}
            payloadData={payload}
            columns={allColumns}
            onToggle={toggleVisibility}
            onReorder={reorder}
            onReset={resetToDefault}
          />
        </div>
        <div className="p-6">
          <div className="relative rounded-lg border bg-card overflow-hidden shadow-sm">
            <ShadcnTable scrollKey="bonusesBonus">
              <TableHeader>
                <TableRow>
                  {visibleIndices.map((origIdx) => (
                    <TableHead key={origIdx} className="whitespace-nowrap">{headers[0][origIdx]}</TableHead>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody>
                {props.bonusData?.data &&
                  props.bonusData.data.length > 0 ? (
                  props.bonusData.data.map((item, index) => (
                    <TableRow key={index}>
                      {visibleIndices.map((origIdx) => (
                        <TableCell key={origIdx} className={bonusCellClassName[origIdx]}>
                          {bonusRowAccessors[origIdx](item)}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))
                ) : (
                  <NoDataFound colspan={visibleIndices.length} />
                )}
              </TableBody>
            </ShadcnTable>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    bonusData: state.bonusSlice.bonusData,
    activePages: state.bonusSlice.activePages,
    paginationFirstValue: state.bonusSlice.paginationFirstValue,
    paginationSecondValue: state.bonusSlice.paginationSecondValue,
    userId: state.playersearch.userId,
    recordsShow: state.bonusSlice.recordsShow,
    isVisible: state.bonusSlice.isVisible,
    freeSpinConfig: state.bonusSlice.freeSpinConfig,
  };
}
export default connect(mapStateToProps)(Bonus);
